import React from 'react';
import PropTypes from 'prop-types';

import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';

import useLocale from 'components/useLocale';
import { DEFAULT_PROPS } from 'constants.js';

import useStyles from './PromptContent.styles';

const { EMPTY_FUNCTION } = DEFAULT_PROPS;

const PromptContent = ({ onCancel = EMPTY_FUNCTION, onConfirm = EMPTY_FUNCTION }) => {
  const locale = useLocale();
  const { buttonsWrapper } = useStyles();

  return (
    <div>
      <div>
        <p>
          {locale['newUser.modal.areYouSureLivePage']} <br />
          {locale['newUser.modal.changesWillBeLost']}
        </p>
      </div>
      <div className={buttonsWrapper}>
        <Button
          autoFocus
          className="btn btn-primary"
          dataQa="route-guard-leave"
          onClick={onConfirm}
          text={locale['common.leave']}
          variant={PRIMARY}
        />
        <Button
          className="btn btn-tertiary"
          dataQa="route-guard-cancel"
          onClick={onCancel}
          text={locale['common.cancel']}
          variant={TERTIARY}
        />
      </div>
    </div>
  );
};

PromptContent.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};

export default PromptContent;
